document.addEventListener("DOMContentLoaded", async () => {

    const jsonUrl = window.colorSwatchUrl;

    try {

        const response = await fetch(jsonUrl);

        const colors = await response.json();

        document.querySelectorAll(".product__color-swatch").forEach(function (swatch) {

            const value = swatch.dataset.optionSwatchValue;

            if (!value) return;

            // Shopify native image swatch
            if (value.startsWith("url(")) {
                swatch.style.backgroundImage = value;
                swatch.style.backgroundSize = "cover";
                return;
            }

            // Shopify native color swatch
            if (value.startsWith("rgb(")) {
                swatch.style.background = value;
                return;
            }

            // JSON fallback
            if (colors[value]) {
                swatch.style.background = colors[value];
            }

        });

    } catch (e) {
        console.error("Unable to load color-swatches.json", e);
    }

});